import { Injectable } from "@angular/core";
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { Platform } from "ionic-angular";
import { Subject } from "rxjs";

@Injectable()
export class ScreenRotatableService {
    onChange = new Subject();

    constructor(
        private screen: ScreenOrientation,
        private platform: Platform
    ) {
        this.screen.onChange().subscribe((data) => {
            this.onChange.next();
        });
    }

    lockPortraitOrientation() {
        if (!this.platform.is('cordova')) return;

        this.screen.lock(this.screen.ORIENTATIONS.PORTRAIT).then(() => {
            console.log('The screen orientation has changed to portrait.');
        }).catch(err => {
            console.log('Error while changing the screen orientation, ' + err);
        });
    }

    unlock() {
        this.screen.unlock();
        console.log('The screen orientation has changed to any')
    }

    getOrientationType() {
        return this.screen.type;
    }
}


// WEBPACK FOOTER //
// /src/providers/screen-rotatable/screen-rotatable.service.ts